var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d4d4d;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.62,13.05,17,14.82V4.05A12,12,0,0,1,27.62,13.05ZM16,28A12,12,0,0,1,15,4.05V16a1,1,0,0,0,1,1h.16L28,15c0,.33.05.65.05,1A12,12,0,0,1,16,28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSector);
export default __webpack_public_path__ + "static/media/sector.e5ad4689ab2a727ba69dcf41e325250d.svg";
export { ForwardRef as ReactComponent };